import React from 'react';
import Fab from '@material-ui/core/Fab';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';

import useStyles from './styles';
 
const WhatsAppButton: React.FC<{}> = () => {
  const classes = useStyles();

  return (<Fab
    classes={ classes }
    color="primary"
    aria-label="whatsapp"
    href="https://api.whatsapp.com/send?phone=+5508009001010&text=&source=&data=&app_absent=">
    <WhatsAppIcon />
  </Fab>);
};

export default WhatsAppButton;